import React from 'react';

import { useFormContext } from 'react-hook-form';

import { Divider, ReadOnlyInput } from '@infoods/lifebase-ui';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { Nutrient } from '../../../../shared/components/ui-components';

import { NUTRIENTS_ENUM } from '../../../../shared/constants/NUTRIENTS_ENUM';
import { useNutrientsTotal } from '../../../hooks/meal-plan-macros';
import { MealPlansMacrosFormValues } from '../../../interfaces/MealPlan';

const nutrientsList = [
  NUTRIENTS_ENUM.PROTEINS,
  NUTRIENTS_ENUM.CARBS,
  NUTRIENTS_ENUM.FATS,
  NUTRIENTS_ENUM.CALORIES,
] as const;

type TotalRowProps = {
  nameIndex: number;
};

const TotalRow = ({ nameIndex }: TotalRowProps) => {
  const { control } = useFormContext<MealPlansMacrosFormValues>();

  const total = useNutrientsTotal(nameIndex);

  return (
    <>
      <Divider />
      <GridTableRow variant="subRow">
        <GridTableCell variant="title">Total</GridTableCell>
        {nutrientsList.map((nutrient) => (
          <GridTableCell variant="title" key={nutrient}>
            <Nutrient nutrient={nutrient}>
              <ReadOnlyInput
                control={control}
                name={`mealPlans.${nameIndex}.total.${nutrient}`}
                value={total[nutrient]}
                valueFont="inherit"
              />
            </Nutrient>
          </GridTableCell>
        ))}
      </GridTableRow>
    </>
  );
};

export { TotalRow };
